/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbAuthModule, NbAuthSocialLink, NbPasswordAuthStrategy } from '@nebular/auth';
import { NbFirebaseAuthModule, NbFirebasePasswordStrategy } from '@nebular/firebase-auth';

import { environment } from '../environments/environment';

import { AngularFireModule } from '@angular/fire/compat';

import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireRemoteConfigModule } from '@angular/fire/compat/remote-config';

import { AuthGuard } from './auth-guard.service';
const socialLinks: NbAuthSocialLink[] = [];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NbEvaIconsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireRemoteConfigModule,
    NbFirebaseAuthModule,
    NbAuthModule.forRoot({
         strategies: [
           NbFirebasePasswordStrategy.setup({
             name: 'password',
           }),
         ],
         forms: {
           login: {
             redirectDelay: 500,
             // delay before redirect after a successful login, while success message is shown to the user
             strategy: 'password',  // strategy id key.
             rememberMe: true,   // whether to show or not the `rememberMe` checkbox
             showMessages: {     // show/not show success/error messages
               success: true,
               error: true,
             },
             socialLinks: socialLinks, // social links at the bottom of a page
           },
           requestPassword: {
             redirectDelay: 500,
             strategy: 'password',
             showMessages: {
               success: true,
               error: true,
             },
             socialLinks: socialLinks,
           },
           logout: {
             redirectDelay: 500,
             strategy: 'password',
           },
         },
       }),
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthGuard,
  ],
})
export class AppModule {
}
